// Central handler for an expired/invalid session (HTTP 401). Clears the stored
// auth and sends the user to /login ONCE. Used by every authFetch so an expired
// token redirects cleanly instead of letting a 401 error-body reach a data
// handler (which crashed the app to a blank screen — setTasks({error}) → .map).
let redirecting = false;

export function handleAuthExpired() {
  if (redirecting) return;
  redirecting = true;
  try {
    localStorage.removeItem('khorezmai_token');
    localStorage.removeItem('khorezmai_user');
  } catch (e) {}
  if (!window.location.pathname.startsWith('/login')) {
    window.location.replace('/login');
  }
}

// 🔐 Hisob uchun 2FA majburiy, lekin hali sozlanmagan (server 403 MFA_SETUP_REQUIRED) —
// token amal qiladi, faqat sozlash sahifasiga o'tkazamiz (docs/knowledge/148).
let toSetup = false;
export function handleMfaSetup() {
  if (toSetup) return;
  toSetup = true;
  if (!window.location.pathname.startsWith('/2fa-setup')) window.location.replace('/2fa-setup');
}
